import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { DayOfYear } from '../day-of-year.js';

export class TaxIdentificationDetails extends DataModel {
  static readonly TYPE_ID: string = '1c5151986b1248b49da2aaaa97b24819';

  private constructor(
    public readonly fullName: string,
    public readonly motherName: string,
    public readonly placeOfBirth: string,
    public readonly dateOfBirth: DayOfYear,
    public readonly taxIdentifier: string,
    public readonly tajNumber: string,
    public readonly homeAddress: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TaxIdentificationDetails.TYPE_ID;
  }

  static create(opts: {
    fullName: string,
    motherName: string,
    placeOfBirth: string,
    dateOfBirth: DayOfYear,
    taxIdentifier: string,
    tajNumber: string,
    homeAddress: string,
  }): TaxIdentificationDetails {
    return new TaxIdentificationDetails(
        opts.fullName,
        opts.motherName,
        opts.placeOfBirth,
        opts.dateOfBirth,
        opts.taxIdentifier,
        opts.tajNumber,
        opts.homeAddress,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): TaxIdentificationDetails {
    return new TaxIdentificationDetails(
        MapUtils.get<string>(map, 'fullName'),
        MapUtils.get<string>(map, 'motherName'),
        MapUtils.get<string>(map, 'placeOfBirth'),
        context.fromData<DayOfYear>(MapUtils.get<SerializedData>(map, 'dateOfBirth')),
        MapUtils.get<string>(map, 'taxIdentifier'),
        MapUtils.get<string>(map, 'tajNumber'),
        MapUtils.get<string>(map, 'homeAddress'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'fullName': this.fullName,
      'motherName': this.motherName,
      'placeOfBirth': this.placeOfBirth,
      'dateOfBirth': context.toData(this.dateOfBirth),
      'taxIdentifier': this.taxIdentifier,
      'tajNumber': this.tajNumber,
      'homeAddress': this.homeAddress,
    };
  }

  clone(): this {
    return new TaxIdentificationDetails(
        this.fullName,
        this.motherName,
        this.placeOfBirth,
        this.dateOfBirth.clone(),
        this.taxIdentifier,
        this.tajNumber,
        this.homeAddress,
    ) as this;
  }

  isSame(other: TaxIdentificationDetails): boolean {
    if(this === other) {
      return true;
    }

    return other.fullName == this.fullName &&
      other.motherName == this.motherName &&
      other.placeOfBirth == this.placeOfBirth &&
      isSameData(other.dateOfBirth, this.dateOfBirth) &&
      other.taxIdentifier == this.taxIdentifier &&
      other.tajNumber == this.tajNumber &&
      other.homeAddress == this.homeAddress;
  }
}

export class TaxIdentificationDetailsBuilder extends DataModelBuilder<TaxIdentificationDetails> {
  build(context: SerializationContext, map: SerializedData): TaxIdentificationDetails {
    return TaxIdentificationDetails.fromMap(context, map);
  }
}
